export const READABLE_IMAGE_TYPES: string[] = ["jpeg", "jpg", "png", "gif", "ico", "svg"];

export const READABLE_FILE_TYPES: string[] = ["pdf", "xls", "xlsx", "docx", "txt", "csv"];
